import { edmCampaign } from '@bingads-webui/edm-campaign';

export const loadAssociatedPageFeeds = (cid, aid, campaignId) =>
  edmCampaign
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .Campaigns.$withKey(campaignId)
    .FeedAssociations
    .get({
      top: 2147483647, // max Int32
    })
    .toPromise()
    .then(({ value }) => value.map(feedAssociation => ({
      key: feedAssociation.FeedId,
      text: feedAssociation.FeedName,
    })));
